/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_VoicesInputs */

const en_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voices`)
};

const fr_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voix`)
};

const de_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimmen`)
};

const it_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voci`)
};

const ru_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голоса`)
};

const es_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces`)
};

const zh_cn2_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`声音`)
};

const ja_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`声`)
};

const hi_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवाज़ें`)
};

const pt_pt2_quicktools_tab_voices = /** @type {(inputs: Quicktools_Tab_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vozes`)
};

/**
* | output |
* | --- |
* | "Voices" |
*
* @param {Quicktools_Tab_VoicesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_voices = /** @type {((inputs?: Quicktools_Tab_VoicesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_VoicesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_voices(inputs)
	if (locale === "de") return de_quicktools_tab_voices(inputs)
	if (locale === "it") return it_quicktools_tab_voices(inputs)
	if (locale === "ru") return ru_quicktools_tab_voices(inputs)
	if (locale === "es") return es_quicktools_tab_voices(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_voices(inputs)
	if (locale === "ja") return ja_quicktools_tab_voices(inputs)
	if (locale === "hi") return hi_quicktools_tab_voices(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_voices(inputs)
	return en_quicktools_tab_voices(inputs)
});